import axios from 'axios';
import { OnlineSales } from 'gw-edge-client';
import { useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { type MissingInformationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/missingInformation';
import { missingInformationAtom } from '../atoms/missingInformationAtom';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { useErrorBoundary } from 'react-error-boundary';
import { GATEWAY_TIMEOUT_STATUS_CODE } from '../../recoil/types/types';

export function useUpdateMissingInformation(goNext: () => void): {
    isWaiting: boolean;
    updateMissingInformation: (missingInformation: MissingInformationDTO) => Promise<void>;
} {
    const [isWaiting, setIsWaiting] = useState(false);
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const setMissingInformation = useSetRecoilState(missingInformationAtom);
    const { showBoundary } = useErrorBoundary();

    const updateMissingInformation = async (
        missingInformation: MissingInformationDTO
    ): Promise<void> => {
        setIsWaiting(true);
        try {
            await OnlineSales.updateMissingInformation(
                jobNumber,
                sessionId,
                missingInformation
            ).then((response) => {
                setMissingInformation(response);
                setIsWaiting(false);
                goNext();
            });
        } catch (err) {
            setIsWaiting(false);
            if (axios.isAxiosError(err) && err.response?.status !== GATEWAY_TIMEOUT_STATUS_CODE) {
                showBoundary(err);
            }
        }
    };

    return { isWaiting, updateMissingInformation };
}
